import { useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

export const promotionalDiscountQueryKeys = {
  all: ['promotionalDiscounts'] as const,
  lists: () => [...promotionalDiscountQueryKeys.all, 'list'] as const,
  list: (vendorAccountId: string) => [...promotionalDiscountQueryKeys.lists(), vendorAccountId] as const,
};

export function useGetPropertyPromotionalDiscounts(vendorAccountId: string | undefined) {
  return useQuery<Array<App.RatePlanPromotion>>({
    queryKey: promotionalDiscountQueryKeys.list(vendorAccountId ?? ''),
    queryFn: async ({ signal }) =>
      ReservationService.getAllPromotionalDiscountsForVendor(vendorAccountId ?? '', { signal }),
    enabled: !!vendorAccountId,
  });
}
